"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconDocument = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var IconDocument = function IconDocument() {
  return react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "26",
    height: "30",
    viewBox: "0 0 54 72"
  }, react_1.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.5)"
  }, react_1.default.createElement("path", {
    fill: "#4DA1FF",
    d: "M4.99947565,72 C2.23834149,72 8.06466005e-13,69.759345 8.06466005e-13,67.0064996 L8.06466005e-13,18.6666667 L18.6666667,-7.10542736e-15 L47.8943715,-7.10542736e-15 C50.6527673,-7.10542736e-15 52.8888889,2.23376942 52.8888889,5.00573628 L52.8888889,66.9942637 C52.8888889,69.7588555 50.6501007,72 47.8894132,72 L4.99947565,72 Z"
  }), react_1.default.createElement("path", {
    fill: "#DBECFF",
    d: "M2.42472709e-12,18.6666667 L13.6643426,18.6666667 C16.4270499,18.6666667 18.6666667,16.4335717 18.6666667,13.6643426 L18.6666667,8.8817842e-15"
  })));
};

exports.IconDocument = IconDocument;